import { SecondaryButton, EmptyState } from '@procurify/ui'

import { useProcurifyIntl, useFeatureFlag } from '@webapp/hooks'
import { BudgetCategoryCardEmptyStateStyled } from './styles/BudgetCategoryCardEmptyStateStyled'
import messages from '../../messages'

export interface IBudgetCategoryCardEmptyStateProps {
  onClickEditCategoryButton?: () => void
}

export const BudgetCategoryCardEmptyState = ({
  onClickEditCategoryButton,
}: IBudgetCategoryCardEmptyStateProps) => {
  const intl = useProcurifyIntl()
  const FT_5817_ENABLE_BUDGETS_REDESIGN = useFeatureFlag(
    'FT_5817_ENABLE_BUDGETS_REDESIGN'
  )
  return (
    <BudgetCategoryCardEmptyStateStyled>
      <EmptyState
        header={intl.formatMessage(
          FT_5817_ENABLE_BUDGETS_REDESIGN
            ? messages.noCurrentDateRange
            : messages.oldNoCurrentDateRange
        )}
        button={
          onClickEditCategoryButton ? (
            <SecondaryButton
              icon='edit'
              onClick={() => onClickEditCategoryButton()}
            >
              {intl.formatMessage(
                FT_5817_ENABLE_BUDGETS_REDESIGN
                  ? messages.editBudget
                  : messages.editCategory
              )}
            </SecondaryButton>
          ) : null
        }
      />
    </BudgetCategoryCardEmptyStateStyled>
  )
}

BudgetCategoryCardEmptyState.displayName = 'BudgetCategoryCardEmptyState'
